import { Toaster } from 'react-hot-toast';

export default function Toast() {
  return (
    <Toaster
      position="top-center"
      reverseOrder={false}
      gutter={12}
      toastOptions={{
        className: 'premium-toast',
        duration: 3500,
        success: {
          className: 'premium-toast-success',
          iconTheme: {
            primary: '#10B981',
            secondary: 'rgba(16, 185, 129, 0.15)',
          },
        },
        error: {
          className: 'premium-toast-error',
          iconTheme: {
            primary: '#EF4444',
            secondary: 'rgba(239, 68, 68, 0.15)',
          },
        },
        loading: {
          className: 'premium-toast-loading',
        },
      }}
    />
  );
}